import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { callPublic } from '../lib/api';
import type { StoreCard } from '../lib/types';

export function Directory() {
  const [stores, setStores] = useState<StoreCard[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [q, setQ] = useState('');

  useEffect(() => {
    document.title = 'Stores';
    callPublic<{ stores: StoreCard[] }>('list_stores')
      .then((r) => setStores(r.stores))
      .catch((e) => setError(e instanceof Error ? e.message : 'Could not load stores.'));
  }, []);

  const shown = (stores || []).filter((s) => !q.trim() || s.displayName.toLowerCase().includes(q.trim().toLowerCase()));

  return (
    <div className="directory">
      <header className="directory-header">
        <h1>Stores</h1>
        <p className="muted">Browse a store, then sign in to order.</p>
        {stores && stores.length > 6 && (
          <input className="input" placeholder="Search stores" value={q} onChange={(e) => setQ(e.target.value)} aria-label="Search stores" />
        )}
      </header>
      {error && <p className="error">{error}</p>}
      {!stores && !error && <p className="muted">Loading…</p>}
      {stores && shown.length === 0 && <p className="muted">No stores yet.</p>}
      <div className="store-grid">
        {shown.map((s) => (
          <Link key={s.slug} to={`/${s.slug}`} className="store-card" style={{ ['--card-accent' as string]: s.primaryColor }}>
            <div className="store-card-logo">
              {s.logoUrl ? <img src={s.logoUrl} alt="" loading="lazy" /> : <span aria-hidden>{s.displayName.slice(0, 1)}</span>}
            </div>
            <div className="store-card-body">
              <h2>{s.displayName}</h2>
              {s.about && <p>{s.about}</p>}
              <span className="muted small">{s.itemsCount} items · {s.categoriesCount} categories</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
